import MUIButton from '@/components/MUI-Components/MUI-Button';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, {memo} from 'react';
import {MobileNumber} from '@/constants';
import {borderRadius, spacing} from '@/styles/tokens';
import {nftButtonSx} from '@/styles/nftButtonSx';

// Migrated from globals.scss `.social-media-button-wrapper` (+ nested `.animated-button`
// override and its 600px `justify-content` override), exclusively owned by this component.
const sxSocialMediaWrapper = {
    gap: spacing[8],
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& .animated-button': {borderRadius: borderRadius.lg},
    '@media (max-width: 600px)': {justifyContent: 'flex-start'}
};

const SocialMedia = (props: any) => {
    const {className} = props;
    const whatsappLinkMobile = `https://wa.me/${MobileNumber}?text=Hi!%20I%20want%20to%20talk%20about%20your%20services%20and%20products.`;
    const whatsappLinkDesktop = `https://web.whatsapp.com/send?phone=${MobileNumber}&text=Hi!%20I%20want%20to%20talk%20about%20your%20services%20and%20products.`;
    const mobileScreen = useMediaQuery('(max-width:480px)');

    const handleWhatsapp = () => {
        const url = mobileScreen ? whatsappLinkMobile : whatsappLinkDesktop;
        globalThis.open(url, '_blank');
    };
    return (
        <Box className={className} sx={sxSocialMediaWrapper}>
            <MUIButton
                onClick={handleWhatsapp}
                label="Connect on Whatsapp"
                variant="contained"
                className="animated-button"
                sx={nftButtonSx}
                aria-label="Connect on Whatsapp"
            />
        </Box>
    );
};

export default memo(SocialMedia);
